import { useQuery } from '@tanstack/react-query';
import { GetClients } from './types';
import { routes } from 'api/routes';
import React from 'react';
import { useAuthStore } from 'store/authStore';
import { axiosGlobalInstance } from 'api/axios/global';

const get = async (): Promise<GetClients[]> => {
  const { data } = await axiosGlobalInstance.get(`${routes['clients']}`);
  return data;
};

const useGetClient = () => {
  // clientId is stored as a zustand value, because it is used in many queryKeys
  // and when it changes causes a refetch in all apis
  const { setClientId, clientId, setRegion } = useAuthStore(state => state);

  const query = useQuery({
    queryKey: [routes['clients']],
    queryFn: get,
    staleTime: Infinity,
  });

  React.useEffect(() => {
    if (query.data && !clientId) {
      const myClient = query.data.find(item => item.role === 'owner');
      setClientId(myClient?.client?.id);
      setRegion(myClient?.client?.region);
    }
  }, [query.data, setClientId, clientId, setRegion]);

  return query;
};

export default useGetClient;
